import {
  ROUTE_PATH,
  REGION_OPTIONS,
  TEMPLATE_OPTIONS,
  GENDERS,
  regions,
  ACTION,
  GENDERLIST_MENTOR,
} from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmMetaSelectModel,
  SmBtnMetaModel,
  SmMetaInputModel,
  SmMetaTextAreaModel,
} from 'common/models/utility-models/meta-model';

export class applicantDashboardMetaModel extends FormMetaModel {
  constructor() {
    super('Applicant Dashboard', '', ROUTE_PATH.applicants, 3);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    // const headers = [
    //   { key: 'id', value: 'id' },
    //   { key: 'considerYear', value: 'considerYear' },
    //   { key: 'applicationId', value: 'applicationId' },
    //   { key: 'firstName', value: 'firstName' },
    // ];

    const headers= [
      { key: 'id', value: 'id' },
      { key: 'considerYear', value: 'considerYear' },
      { key: 'applicationId', value: 'applicationId' },
      { key: 'firstName', value: 'firstName' },
      { key: 'middleName', value: 'middleName' },
      { key: 'lastName', value: 'lastName' },
      { key: 'gender', value: 'gender' },
      { key: 'age', value: 'age' },
      { key: 'mobileNumber', value: 'mobileNumber' },
      { key: 'email', value: 'email' },
      { key: 'alternativeEmail', value: 'alternativeEmail' },
      { key: 'fatherName', value: 'fatherName' },
      { key: 'motherName', value: 'motherName' },
      { key: 'fatherProfession', value: 'fatherProfession' },
      { key: 'motherProfession', value: 'motherProfession' },
      { key: 'familyAnnualIncome', value: 'familyAnnualIncome' },
      { key: 'score10', value: 'score10' },
      { key: 'score12', value: 'score12' },
      { key: 'physicsMarks', value: 'physicsMarks' },
      { key: 'chemistryMarks', value: 'chemistryMarks' },
      { key: 'mathematicsMarks', value: 'mathematicsMarks' },
      { key: 'jeeScore', value: 'jeeScore' },
      { key: 'instituteName', value: 'instituteName' },
      { key: 'instituteType', value: 'instituteType' },
      { key: 'instituteContact', value: 'instituteContact' },
      { key: 'instituteAddress', value: 'instituteAddress' },
      { key: 'district', value: 'district' },
      { key: 'city', value: 'city' },
      { key: 'batch_number', value: 'batch_number' },
      { key: 'unique_batch_id', value: 'unique_batch_id' },
      { key: 'firstYearFees', value: 'firstYearFees' },
      { key: 'anyScholarshipName', value: 'anyScholarshipName' },
      { key: 'offeringInstitute', value: 'offeringInstitute' },
      { key: 'scholarshipAmount', value: 'scholarshipAmount' },
      { key: 'orgname', value: 'orgname' },
      { key: 'orgmobile', value: 'orgmobile' },
      { key: 'orggender', value: 'orggender' },
      { key: 'orgfamilyAnnualIncome', value: 'orgfamilyAnnualIncome' },
      { key: 'orgphysicsMarks', value: 'orgphysicsMarks' },
      { key: 'orgchemistryMarks', value: 'orgchemistryMarks' },
      { key: 'orgmathematicsMarks', value: 'orgmathematicsMarks' },
      { key: 'orgjeeScore', value: 'orgjeeScore' },
      { key: 'status', value: 'status' },
      { key: 'statusDate', value: 'statusDate' },
      { key: 'callCount', value: 'callCount' },
      { key: 'callStatus', value: 'callStatus' },
      { key: 'callRemark', value: 'callRemark' },
      { key: 'callRemarkDate', value: 'callRemarkDate' },
      { key: 'callRemarkByAdminId', value: 'callRemarkByAdminId' },
      { key: 'isRejected', value: 'isRejected' },
      { key: 'rejectedDate', value: 'rejectedDate' },
      { key: 'created', value: 'created' },
      { key: 'modified', value: 'modified' },
      { key: 'isSaved', value: 'isSaved' },
      { key: 'lastSavedDate', value: 'lastSavedDate' },
      { key: 'assessmentMarks', value: 'assessmentMarks' },
      { key: 'assessmentMaxMarks', value: 'assessmentMaxMarks' },
      { key: 'AssessmentType', value: 'AssessmentType' },
      { key: 'assessmentSubmitDate', value: 'assessmentSubmitDate' },
      { key: 'interviewScore', value: 'interviewScore' },
      { key: 'interviewStatus', value: 'interviewStatus' },
      { key: 'interviewFeedback', value: 'interviewFeedback' },
      { key: 'interviewFeedbackSubmitDate', value: 'interviewFeedbackSubmitDate' },
      { key: 'homeVisitScore', value: 'homeVisitScore' },
      { key: 'homeVisitTotal', value: 'homeVisitTotal' },
      { key: 'homeVisitOccupationScore', value: 'homeVisitOccupationScore' },
      { key: 'homeVisitParentEduScore', value: 'homeVisitParentEduScore' },
      { key: 'homeVisitHousingAssetsScore', value: 'homeVisitHousingAssetsScore' },
      { key: 'homeVisitSocialSkillScore', value: 'homeVisitSocialSkillScore' },
      { key: 'homeVisitRemark', value: 'homeVisitRemark' },
      { key: 'homevisitSubmitDate', value: 'homevisitSubmitDate' },
      { key: 'AllRank', value: 'AllRank' },
      { key: 'AllIndiaRank', value: 'AllIndiaRank' },
      { key: 'ZoneRank', value: 'ZoneRank' },
      { key: 'StateRank', value: 'StateRank' },
      { key: 'rankModifiedDate', value: 'rankModifiedDate' },
      { key: 'dueDeligenceStatusDate', value: 'dueDeligenceStatusDate' },
      { key: 'documentationStatusDate', value: 'documentationStatusDate' },
      { key: 'assessmentStatusDate', value: 'assessmentStatusDate' },
      { key: 'interviewStatusDate', value: 'interviewStatusDate' },
      { key: 'homeVisitStatusDate', value: 'homeVisitStatusDate' },
      { key: 'shortlistingStatusDate', value: 'shortlistingStatusDate' },
      { key: 'shortlistedStatusDate', value: 'shortlistedStatusDate' },
      { key: 'addToPortalFlag', value: 'addToPortalFlag' },
      { key: 'studentId', value: 'studentId' },
      { key: 'branchCatName', value: 'branchCatName' },
      { key: 'branch_name', value: 'branch_name' },
      { key: 'stateName', value: 'stateName' },
      { key: 'collageStateName', value: 'collageStateName' },
      { key: 'callByAdminName', value: 'callByAdminName' },
      { key: 'DocVerifiedCount', value: 'DocVerifiedCount' },
      { key: 'DocUploadedCount', value: 'DocUploadedCount' },
      { key: 'TotalHMScore11', value: 'TotalHMScore11' },
      { key: 'TotalHMScore', value: 'TotalHMScore' },
      { key: 'callStatusTitle', value: 'callStatusTitle' },
      { key: 'Total', value: 'Total' },
      { key: 'statusFlag', value: 'statusFlag' },
      { key: 'AllMarksSum', value: 'AllMarksSum' },
      { key: 'isResend', value: 'isResend' },
      { key: 'isAllDocUploaded', value: 'isAllDocUploaded' },
      { key: 'isAllDocVerified', value: 'isAllDocVerified' },
      { key: 'uploadedDocuments', value: 'uploadedDocuments' },
      { key: 'DocAskedCount', value: 'DocAskedCount' },
      { key: 'alternate number', value: 'alternate number' }
    ];

    const selectedRegion = new SmMetaSelectModel(
      'selectedRegion',
      'selectedRegion',
      'select',
      false,
      'col-2-4',
      1,
      1,
      'Region',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      regions,
      'name',
      'value',
      false,
      false,
      false,
      false,
      false,
      false,
      { evalKey: '', evalParam: [] },
      null,
      false,
      [],
      false
    );

    const selectedState = new SmMetaSelectModel(
      'selectedState',
      'selectedState',
      'select',
      false,
      'col-2-4',
      1,
      2,
      'State',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'stateName',
      'id',
      false,
      false,
      false,
      false,
      false,
      false,
      { evalKey: '', evalParam: [] },
      null,
      false,
      [],
      false
    );

    const allGenders = new SmMetaSelectModel(
      'allGenders',
      'allGenders',
      'select',
      false,
      'col-2-4',
      1,
      2,
      'Gender',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      'name',
      'value',
      false,
      false,
      false,
      false,
      false,
      false,
      { evalKey: '', evalParam: [] },
      null,
      false,
      [],
      false
    );

    // const department = new SmMetaSelectModel(
    //   'department',
    //   'department',
    //   'select',
    //   false,
    //   'col-sm-6 col-xs-12 col-md-4 col-lg-3',
    //   1,
    //   3,
    //   '',
    //   '',
    //   'Department',
    //   false,
    //   true,
    //   true,
    //   false,
    //   0,
    //   0,
    //   false,
    //   TEMPLATE_OPTIONS,
    //   'name',
    //   'id'
    // );

    // const action = new SmMetaSelectModel(
    //   'action',
    //   'action',
    //   'select',
    //   false,
    //   'col-sm-6 col-xs-12 col-md-4 col-lg-3',
    //   1,
    //   3,
    //   '',
    //   'select',
    //   'Action',
    //   false,
    //   true,
    //   true,
    //   false,
    //   0,
    //   0,
    //   false,
    //   GENDERS,
    //   'name',
    //   'id'
    // );

    const action = new SmMetaSelectModel(
      'action',
      'action',
      'select',
      false,
      'col-2-4',
      1,
      2,
      'Action',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ACTION,
      'name',
      'id',
      false,
      false,
      false,
      false,
      false,
      false,
      { evalKey: '', evalParam: [] },
      null,
      false,
      [],
      false
    );

    // const topStudentCount = new SmMetaSelectModel(
    //   'topStudentCount',
    //   'topStudentCount',
    //   'select',
    //   false,
    //   'col-sm-6 col-xs-12 col-md-4 col-lg-3',
    //   1,
    //   3,
    //   '',
    //   'select',
    //   'Top Students',
    //   false,
    //   true,
    //   true,
    //   false,
    //   0,
    //   0,
    //   false,
    //   GENDERS,
    //   'name',
    //   'id'
    // );

    const topStudentCount = new SmMetaInputModel(
      'topStudentCount',
      'topStudentCount',
      'input',
      true,
      'col-2-4',
      1,
      4,
      'Top Students',
      'text',
      '',
      false,
      true,
      true,
      false,
      50,
      1
    );

    const filterRemark = new SmMetaTextAreaModel(
      'filterRemark',
      'filterRemark',
      'textarea',
      false,
      'col-12 col-md-12 ',
      1,
      5,
      'Description',
      'textarea',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const from = new SmMetaInputModel(
      'from',
      'from',
      'input',
      false,
      'col-2-4',
      1,
      4,
      'From',
      'number',
      '',
      false,
      true,
      true,
      false,
      50,
      1
    );

    const to = new SmMetaInputModel(
      'to',
      'to',
      'input',
      false,
      'col-2-4',
      1,
      4,
      'To',
      'number',
      '',
      false,
      true,
      true,
      false,
      50,
      1
    );

    const buttons = {
      submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
      isFormControl: false,
    };

    return {
      formInfo,
      //  region_search,
      //  state_search,
      //  gender_search,
      topStudentCount,
      buttons,
      headers,
      selectedRegion,
      selectedState,
      // department,
      allGenders,
      action,
      filterRemark,
      from,
      to
    };
  }
}
